import React, { useEffect, useState } from "react";
import requestApi from "../../apirest/index";
import { toast } from "react-toastify";
import Loading from "../../shared/components/Loading/Loading";
import NumberFormat from 'react-number-format';
import CostItemsTable, { UNIT_OPTIONS } from "./components/CostItemsTable";
import "./components/CostTabLayout.css";

const Prototype = ({ onPrototypeChange, productFinded, savedId }) => {
  const [textiles, setTextiles] = useState([{
    amount: 0,
    quantity: 1,
    description: "teste"
  }]);
  const [id, setId] = useState(null);
  const [patternDesignCost, setPatternDesignCost] = useState(0);
  const [product, setProduct] = useState(productFinded);
  const [totalAmountTextiles, setTotalAmountTextiles] = useState(0);
  const [totalAmountNotions, setTotalAmountNotions] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [notions, setNotions] = useState([{
    amount: 0,
    quantity: 1,
    description: "teste"
  }]);

  const [loading, setLoading] = useState(false);

  const companies = [
    "Carla Confecções",
    "Terra Textil",
    "Alpino",
    "Telma Confecções",
    "Gustavo",
    "Empresa",
    "Textil Suiça",
    "Rellus",
    "Master",
    "Otimotex/ Mere",
    "Suiça Textil",
    "Confeccção",
    "Movvi",
    "STAMPA",
    "Lucin",
  ];


  const findPrototypeByProduct = async () => {
    setLoading(true);
    try {
      const idProduct = productFinded._id;
      const res = await requestApi(`/prototype/findByIdProduct`, idProduct, "get");
      const prototype = res?.data?.doc[0];
      console.log("chegoiu aqui prototyope", prototype);
      setLoading(false);
      // Atualiza todos de uma vez
      if (prototype) {
        setProduct(prototype.product);
        setTextiles(prototype.textiles);
        setId(prototype._id);
        setNotions(prototype.notions);
        setTotalAmountTextiles(prototype.totalAmountTextiles);
        setTotalAmountNotions(prototype.totalAmountNotions);
        setTotalAmount(prototype.totalAmount);
        setPatternDesignCost(prototype.patternDesignCost);
      } else {
        setProduct(productFinded);
        setTextiles([{
          amount: 0,
          quantity: 1,
          description: "teste"
        }]);
        setNotions([{
          amount: 0,
          quantity: 1,
          description: "teste"
        }]);
        setTotalAmountTextiles(0);
        setTotalAmountNotions(0);
        setTotalAmount(0);
        setPatternDesignCost(0);
      }
    } catch (error) {
      console.log(error);
      toast.error("Aconteceu algum erro inesperado.", {
        autoClose: 4000,
      });

      setLoading(false);
    }
  };

  useEffect((() => {
    findPrototypeByProduct();
  }), [productFinded])

  // Sincroniza o id local com o id real recebido do pai após salvar, senão
  // o próximo save reporta id=null de novo e cria um registro duplicado.
  useEffect(() => {
    if (savedId) setId(savedId);
  }, [savedId]);

  useEffect(() => {
    const total = notions.reduce((acc, item) => acc + item.totalAmount, 0);
    setTotalAmountNotions(total);
  }, [notions]);

  useEffect(() => {
    const total = textiles.reduce((acc, item) => acc + item.totalAmount, 0);
    setTotalAmountTextiles(total);
  }, [textiles]);

  useEffect(() => {
    const total =
      totalAmountNotions + totalAmountTextiles + patternDesignCost;
    setTotalAmount(total);

    // Notifica o componente pai sobre as mudanças
    if (onPrototypeChange) {
      onPrototypeChange({
        product,
        textiles,
        notions,
        totalAmountTextiles,
        totalAmountNotions,
        totalAmount: total,
        patternDesignCost,
        id
      });
    }
  }, [
    product,
    textiles,
    notions,
    totalAmountNotions,
    totalAmountTextiles,
    totalAmount,
    patternDesignCost
  ]);


  const update = (lista, tipo, novoValor, atributo, index) => {

    const listaAtualizados = lista.map((item, i) => {
      if (i === index) {
        const quantity = atributo === "quantity" ? novoValor : item.quantity;
        const amount = atributo === "amount" ? novoValor : item.amount;
        const totalAmount = quantity * amount;
        return { ...item, [atributo]: novoValor, totalAmount };
      }
      return item; // Retornar o objeto original se não for o índice correspondente
    });

    atualizarListas(tipo, listaAtualizados);
  };


  const add = async (lista, tipo) => {
    const novaLista = [
      ...lista,
      {
        amount: 0,
        description: "teste",
      },
    ];

    atualizarListas(tipo, novaLista);
  }

  const deleteObjeto = (lista, tipo, index) => {
    // Verifica se o índice é válido
    if (index < 0 || index >= lista.length) {
      console.error("Índice inválido");
      return;
    }

    // Cria uma cópia do array original
    const novaLista = [...lista];

    // Remove o objeto no índice especificado
    novaLista.splice(index, 1);

    atualizarListas(tipo, novaLista);
  };


  function atualizarListas(tipo, novos) {
    if (tipo === "notions") {
      setNotions(novos);
      const total = novos.reduce((acc, item) => acc + item.totalAmount, 0);
      setTotalAmountNotions(total);
    } else {
      setTextiles(novos);
      const total = novos.reduce((acc, item) => acc + item.totalAmount, 0);
      setTotalAmountTextiles(total);
    }
  }




  const textileColumns = [
    { key: "description", label: "Descrição", type: "text" },
    { key: "company", label: "Empresa", type: "select", options: companies },
    { key: "unit", label: "Unidade", type: "select", options: UNIT_OPTIONS },
    { key: "quantity", label: "Quantidade", type: "number" },
    { key: "amount", label: "Valor Unitário", type: "currency" },
  ];

  const renderPrototype = () => {
    return <div className="cost-tab-page">
      <div className="cp-card cost-summary-card">
        <div className="cp-field" hidden={!product?._id}>
          <label className="cp-label">Custo de piloto</label>
          <NumberFormat
            className="cp-input"
            value={patternDesignCost}
            displayType="input"
            thousandSeparator="."
            prefix="R$"
            decimalScale={2}
            fixedDecimalScale={true}
            onValueChange={(values) => setPatternDesignCost(values.floatValue)}
            decimalSeparator=","
          />
        </div>
      </div>

      {productFinded?._id && (
        <div className="cp-card cost-tab-card">
          <CostItemsTable
            title="Custos de Tecidos"
            items={textiles}
            columns={textileColumns}
            totalLabel="Total tecidos"
            totalValue={totalAmountTextiles}
            onAdd={() => add(textiles, "textiles")}
            onUpdate={(index, key, value) => update(textiles, "textiles", value, key, index)}
            onDelete={(index) => deleteObjeto(textiles, "textiles", index)}
          />
          <CostItemsTable
            title="Custos de Aviamentos"
            items={notions}
            columns={textileColumns}
            totalLabel="Total aviamentos"
            totalValue={totalAmountNotions}
            onAdd={() => add(notions, "notions")}
            onUpdate={(index, key, value) => update(notions, "notions", value, key, index)}
            onDelete={(index) => deleteObjeto(notions, "notions", index)}
          />
        </div>
      )}

      {productFinded?._id && (
        <div className="cost-grand-total">
          <span>Total piloto</span>
          <strong>
            <NumberFormat
              value={totalAmount}
              displayType="text"
              thousandSeparator="."
              prefix="R$"
              decimalScale={2}
              fixedDecimalScale={true}
              decimalSeparator=","
            />
          </strong>
        </div>
      )}

      {
        loading && <Loading overlay />
      }
    </div>;
  }

  return (
    <>
      {renderPrototype()}
    </>
  );


};

export default Prototype;


